define('backbone_view_multiple.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('backbone_view_multiple', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"backbone-view-multiple\"> "
    + ((stack1 = _nl_(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"placeholderIds") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":37},"end":{"line":1,"column":140}}})) != null ? stack1 : "")
    + " </div> ";
},"1":function(container,depth0,helpers,partials,data) {
    return " <div class=\"backbone-view-multiple-view\" data-view=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></div> ";
},"useData":true}, 'extensions/Digi/DigiSummit/3.1.0/', 'extensions/Digi/DigiSummit/3.1.0/', Handlebars);
});